export const OPEN_FAN_KEY = 'job-matching';

const store = {
	namespaced: true,
	state: {
		show: false,
		job: undefined,
		jobProfile: undefined,
		hasOngoingConversation: undefined,
		favored: undefined,
		notice: undefined,
		exclusion: undefined,
		withActions: undefined,
		onContacted: undefined,
		onFavoriteChange: undefined,
		onNoticeChange: undefined,
		onExclusionChange: undefined,
	},
	actions: {
		show ({commit}, data)
		{
			commit('layout/addOpenFan', OPEN_FAN_KEY, {root: true});

			commit('setJob', data.job);
			commit('setJobProfile', data.jobProfile);
			commit('setHasOngoingConversation', data.hasOngoingConversation);
			commit('setFavored', data.favored);
			commit('setNotice', data.notice);
			commit('setExclusion', data.exclusion);
			commit('setWithActions', data.withActions);
			commit('setOnContacted', data.onContacted);
			commit('setOnFavoriteChange', data.onFavoriteChange);
			commit('setOnNoticeChange', data.onNoticeChange);
			commit('setOnExclusionChange', data.onExclusionChange);

			commit('setShow', true);
		},
		close ({commit})
		{
			commit('setShow', false);

			commit('setJob', undefined);
			commit('setJobProfile', undefined);
			commit('setHasOngoingConversation', undefined);
			commit('setFavored', undefined);
			commit('setNotice', undefined);
			commit('setExclusion', undefined);
			commit('setWithActions', undefined);
			commit('setOnContacted', undefined);
			commit('setOnFavoriteChange', undefined);
			commit('setOnNoticeChange', undefined);
			commit('setOnExclusionChange', undefined);

			commit('layout/removeOpenFan', OPEN_FAN_KEY, {root: true});
		},
	},
	mutations: {
		setShow: (state, value) => state.show = value,
		setJob: (state, value) => state.job = value,
		setJobProfile: (state, value) => state.jobProfile = value,
		setHasOngoingConversation: (state, value) => state.hasOngoingConversation = value,
		setFavored: (state, value) => state.favored = value,
		setNotice: (state, value) => state.notice = value,
		setExclusion: (state, value) => state.exclusion = value,
		setWithActions: (state, value) => state.withActions = value,
		setOnContacted: (state, value) => state.onContacted = value,
		setOnFavoriteChange: (state, value) => state.onFavoriteChange = value,
		setOnNoticeChange: (state, value) => state.onNoticeChange = value,
		setOnExclusionChange: (state, value) => state.onExclusionChange = value,
	},
};

export default store;
